export const calendarFeedQueryKeys = {
  all: () => ['calendar_feed']
}
